module.exports = __webpack_public_path__ + "img/Steve-M.6b4aa980.jpeg";